<script>
  import Select from 'svelte-select';

  import { nameCol, countryCol, imgBasePath } from '../config';
  import { data, selectedProduct, activeCountry } from '../stores';
  import { sortByKey } from '../utils';

  $: items = $data
    .map(d => ({
      value: d[nameCol],
      label: d[nameCol],
      iso: d[countryCol]
    }))
    .sort(sortByKey('label'));

  const handleSelect = selectedVal => {
    const dataItem = $data.find(d => d[nameCol] === selectedVal.detail.value);
    activeCountry.set(dataItem[countryCol]);
  };

  const handleClear = () => {
    activeCountry.set(null);
  };
</script>

<style>
  .km-products {
    margin-left: auto;
    width: 100%;
  }

  .km-products :global(.item) {
    padding: 0 5px;
  }

  .km-products :global(.item.active) {
    background: #f3f3f3;
  }

  .km-products :global(.km-select__item) {
    display: flex;
    width: 100%;
    cursor: pointer;
    color: #888;
    font-size: 12px;
    height: 100%;
    padding-left: 12px;
  }
  .km-products :global(.km-select__item img) {
    width: 16px;
    margin-left: auto;
  }

  .listItem > .item {
    padding: 0 10px;
  }

  .km-products :global(.item.hover) {
    background: #f3f3f3;
  }

  .km-products :global(.clearSelect) {
    cursor: pointer;
  }

  .km-products :global(.selectedItem) {
    font-size: 12px;
  }

  .km-products:hover {
    border-color: #888;
  }

  .km-products:focus {
    border-color: #888;
  }

  :global(.themed--placeholderColor) {
    color: #888;
    font-size: 13px;
  }

  @media screen and (min-width: 800px) {
    .km-products {
      max-width: 400px;
    }
  }
</style>

<div class="km-products">
  <div class="km-title">Produkt finden:</div>
  <Select
    {items}
    bind:selectedValue={$selectedProduct}
    on:select={handleSelect}
    on:clear={handleClear}
    isVirtualList={true}
    placeholder="Nach Produkt suchen…"
    getOptionLabel={option => `<div class="km-select__item">${option.label} <img src="${imgBasePath}flags/${option.iso}.svg" /></div>`}
    noOptionsMessage="keine Produkte gefunden"
    listAutoWidth={false}
    containerStyles="color: #888; background: #f3f3f3; border-color: #ffffff;"
    inputStyles="font-size: 12px; font-family: axiforma; padding-left: 12px;
    color: #888; font-weight: 700;" />
</div>
